const notificationEventTypes = {
    FileCompleted: 'File Completed',
    TaggedUserComparisonComment: 'Tagged User Comparison Comment',
};
export default notificationEventTypes;
